import { FC } from 'react'
import clsx from 'clsx'
import { IconSvg } from 'components/common'

interface SocialLinkProps {
	icon: string
	href: string
	title: string
	className?: string
}

const SocialLink: FC<SocialLinkProps> = ({ icon, href, title, className }) => (
	<a
		target="_blank"
		rel="noopener noreferrer"
		className={clsx('transition-all duration-300 flex items-center justify-center rounded-full', className)}
		href={href}
		title={title}
	>
		<IconSvg icon={icon} />
	</a>
)

export default SocialLink
